import{getDefaultExportFromCjs as o}from"./_commonjsHelpers.js";import{__require as r}from"../node_modules/dayjs/dayjs.min.js";var s=o(r());export{s as default};
